const BlogHero = () => {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden mt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4be1a7dfa9fdd8699af1f8c640ca21e7.jpg"
          alt="Black mother holding newborn baby in admiration"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-serif">
          Birth Stories
        </h1>
        <p className="text-xl md:text-2xl text-white/95 font-light leading-relaxed">
          Real journeys, real experiences, real mothers sharing their sacred birth stories
        </p>
      </div>
    </section>
  );
};

export default BlogHero;
